import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { fetchMe } from 'redux/users/actions';
import { fetchCommerceLinksList } from 'redux/commerce/actions';
import {
  deletePaymentProvider,
  clearDeletePaymentProvider,
  patchPaymentProvider,
  clearPatchPaymentProvider,
  fetchPaymentProviderOnboardingLink,
  clearPaymentProviderOnboardingLink,
} from 'redux/billing/actions';

// import { Dropdown } from 'semantic-ui-react';

import CommonInputField
  from 'components/elements/inputs/CommonInputField';
import CommonModal from 'components/elements/modals/CommonModal';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import './EditPaymentProviderModal.css';

function EditPaymentProviderModal(props) {
  const {
    fetchMe,
    fetchCommerceLinksList,
    deletePaymentProvider,
    clearDeletePaymentProvider,
    patchPaymentProvider,
    clearPatchPaymentProvider,
    item,
    open,
    onClose,
    deletePaymentProviderSuccess,
    patchPaymentProviderSuccess,
    patchPaymentProviderError,
    fetchPaymentProviderOnboardingLink,
    clearPaymentProviderOnboardingLink,
    paymentProviderOnboardingLink,
    // currencies,
  } = props;

  const [deleteProvider, setDeleteProvider] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (open) {
      fetchPaymentProviderOnboardingLink(item.id);
    }
  }, [open]);

  useEffect(() => {
    if (patchPaymentProviderSuccess) {
      fetchMe(false);
      fetchCommerceLinksList();
      clearPatchPaymentProvider();
    }
  }, [patchPaymentProviderSuccess]);

  useEffect(() => {
    if (deletePaymentProviderSuccess) {
      fetchMe();
      fetchCommerceLinksList();
      clearDeletePaymentProvider();
      onModalClose();
    }
  }, [deletePaymentProviderSuccess]);

  const onModalClose = () => {
    onClose();
    setDeleteProvider(false);
    clearPaymentProviderOnboardingLink();
  };

  const onPatchPaymentProvider = (parameter, value) => {
    const form = new FormData();
    form.append(parameter, value);
    patchPaymentProvider(item.id, form);
  };

  // const currenciesOptions = currencies ?
  //   currencies.map(
  //     currency => (
  //       {
  //         key: currency.currency_code,
  //         text: currency.currency_code,
  //         value: currency.id,
  //         symbol: currency.currency_symbol,
  //       }
  //     ),
  //   ) : [];

  const renderEditProvider = (
    <div className="edit-provider-wrapper">
      <div className="header">{t("Edit your")} {item.provider_title} {t("account")}</div>

      <div className="payment-provider">
        <div className="provider">
          <div className={`icon ${item.provider_name.toLowerCase()}`} />
          <div className="provider-title">{item.provider_title}</div>
        </div>
        <div className="status-label">
          <div className="icon connected" />
          <div className="status">{t("Connected")}</div>
        </div>
      </div>

      {!item.charges_enabled && !item.details_submitted &&
        <div className="onboarding">
          <span className="alert">{t("Payments are currently disabled.")}</span><br/>
          {paymentProviderOnboardingLink && !paymentProviderOnboardingLink.onboarding_link &&
            <div>
              {t("It seems like this account has been removed in Stripe. You can try to")}&nbsp;
              <a href="https://dashboard.stripe.com/login">
                {t("log in to Stripe and solve the issue")}
              </a>&nbsp;
              {t("or reach out to our support")}: <a href="mailto:team@heylink.me">team@heylink.me</a>.
            </div>
          }

          {paymentProviderOnboardingLink && paymentProviderOnboardingLink.onboarding_link &&
            <div>
              {t("To enable payments please")}&nbsp;
              <a href={paymentProviderOnboardingLink.onboarding_link.url}>
                {t("follow the onboarding flow")}
              </a>.
            </div>
          }
        </div>
      }

      {!item.charges_enabled && item.details_submitted &&
        <div className="onboarding">
          {t("All required details has been submitted. Verification is in progress.")}
        </div>
      }

      <div className="fields-wrapper">
        <CommonInputField
          key={`payment-provider-title-input-key-${item.id}`}
          label={t("Title")}
          initialValue={item.provider_title}
          executedFunction={value => {
            onPatchPaymentProvider('provider_title', value);
          }}
        />

        {/*<div className="dropdown-wrapper">*/}
        {/*  <div className="label">Currency</div>*/}
        {/*  <Dropdown*/}
        {/*    fluid*/}
        {/*    search*/}
        {/*    selection*/}
        {/*    value={item.currency}*/}
        {/*    options={currenciesOptions}*/}
        {/*    onChange={(_e, data) => {*/}
        {/*      onPatchPaymentProvider('currency', data.value);*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</div>*/}

        {/* Server Errors */}
        {patchPaymentProviderError &&
          <CommonMessage
            error
            errors={patchPaymentProviderError}
          />
        }
      </div>

      <div className="buttons-block">
        <Button
          small
          borderedBlue
          onClick={onModalClose}
        >
          {t("Cancel")}
        </Button>
        <div
          className="delete-button"
          onClick={() => setDeleteProvider(true)}
          role="button"
          tabIndex={-1}
        >
          <div className="icon" />
          <div className="text">{t("Delete")}</div>
        </div>
      </div>
    </div>
  );

  const renderDeleteProvider = (
    <div className="delete-provider-wrapper">
      <div className="header">{t("Delete")} {item.provider_title} {t("account")}?</div>
      <div className="text">
        {t("Are you sure you want to delete this account?")}
      </div>
      <CommonMessage info>
          {t("It seems you are trying to remove your connected Payment Provider. " +
             "It will be permanently removed and all associated Commerce Links " +
             "will be deactivated. Please type “Remove Provider” to proceed.")}
      </CommonMessage>
      <div className="buttons-block">
        <Button
          small
          onClick={() => deletePaymentProvider(item.id)}
        >
          {t("Remove Provider")}
        </Button>
        <Button
          small
          borderedBlue
          onClick={() => setDeleteProvider(false)}
        >
          {t("Cancel")}
        </Button>
      </div>
    </div>
  );

  return (
    <CommonModal
      className="edit-payment-provider-modal__component"
      open={open}
      onClose={onModalClose}
    >
      {!deleteProvider ? renderEditProvider : renderDeleteProvider}
    </CommonModal>
  );
}

EditPaymentProviderModal.propTypes = {
  fetchMe: PropTypes.func.isRequired,
  fetchCommerceLinksList: PropTypes.func.isRequired,
  deletePaymentProvider: PropTypes.func.isRequired,
  clearDeletePaymentProvider: PropTypes.func.isRequired,
  patchPaymentProvider: PropTypes.func.isRequired,
  clearPatchPaymentProvider: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  item: PropTypes.object,
  open: PropTypes.bool.isRequired,
  deletePaymentProviderSuccess: PropTypes.object,
  patchPaymentProviderSuccess: PropTypes.object,
  patchPaymentProviderError: PropTypes.object,
  // currencies: PropTypes.arrayOf(PropTypes.shape),
};

EditPaymentProviderModal.propTypes = {
  item: null,
  deletePaymentProviderSuccess: null,
  patchPaymentProviderSuccess: null,
  patchPaymentProviderError: null,
  // currencies: null,
};

const mapStateToProps = state => (
  {
    // currencies: state.commonReducer.currencies,
    deletePaymentProviderSuccess: state.billingReducer.deletePaymentProviderSuccess,
    patchPaymentProviderSuccess: state.billingReducer.patchPaymentProviderSuccess,
    patchPaymentProviderError: state.billingReducer.patchPaymentProviderError,
    paymentProviderOnboardingLink: state.billingReducer.paymentProviderOnboardingLink,
    paymentProviderOnboardingLinkError: state.billingReducer.paymentProviderOnboardingLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    fetchCommerceLinksList,
    deletePaymentProvider,
    clearDeletePaymentProvider,
    patchPaymentProvider,
    clearPatchPaymentProvider,
    fetchPaymentProviderOnboardingLink,
    clearPaymentProviderOnboardingLink,
  },
)(EditPaymentProviderModal);
